import { Files } from "../context/Main.context";
import { uploadToFirebase } from "./firebase";

type DocumentsURLs = {
    autorizationFile: string | null;
    parentalAuth: string | null;
    certif: string | null,
    healthForm: string | null,
    idPhotos: string | null,
    mutationFile: string | null,
    idDocument: string | null,
}

export const handleFileUpload = async (files: Files) => {
    var urls: DocumentsURLs = {
        autorizationFile: null,
        parentalAuth: null,
        certif: null,
        healthForm: null,
        idPhotos: null,
        mutationFile: null,
        idDocument: null,
    };
    console.log(files);
    if(files.autorizationFile) {
        urls.autorizationFile = await uploadToFirebase(files.autorizationFile, "authorizations");
    }

    if(files.parentalAuth) {
        urls.parentalAuth = await uploadToFirebase(files.parentalAuth, "parentals");
    }

    if(files.certif) {
        urls.certif = await uploadToFirebase(files.certif, "medicals/certifs");
    }

    if(files.healthForm) {
        urls.healthForm = await uploadToFirebase(files.healthForm, "medicals/questions");
    }

    if(files.idPhotos) {
        urls.idPhotos = await uploadToFirebase(files.idPhotos, "id-photos");
    }

    if(files.mutationFile) {
        urls.mutationFile = await uploadToFirebase(files.mutationFile, "mutations");
    }

    if(files.idDocument) {
        urls.idDocument = await uploadToFirebase(files.idDocument, "idDocuments");
    }

    console.log(urls);

    return urls;
}